<template>
  <div>
    <v-overlay :z-index="5000" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div v-if="!ReqMode" class="word_keeper">
      <v-card class="ma-4" id="head_height">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">mdi-account-switch-outline</v-icon>협력업체 관리자 신청 현황
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-btn @click="Initialize();" icon small>
            <v-icon>
              refresh
            </v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>

        <v-card-text class="mt-2">
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="12" class="d-flex">
              <div class="d-flex mb-n6">
                <IronDate ref="IronDateRef" v-model="sNowSelectDate" @update="onDateRangeChange" cLabel="신청일자" style="width:230px;" class="mr-4 hidden-md-and-down"/>
                <v-select
                  v-model="cState"
                  :items="zDefaultState"
                  @change="GetChangeManagerlog()"
                  label="진행상태"
                  class="mr-4 hidden-md-and-down"
                  style="width:120px;"
                  dense
                  hide-details
                ></v-select>
                <v-select
                  v-model="cManagerState"
                  :items="zCorpManager"
                  @change="GetChangeManagerlog()"
                  label="정/부 협력업체 관리자"
                  class="mr-4 hidden-md-and-down"
                  style="width:120px;"
                  dense
                  hide-details
                ></v-select>
                <v-text-field v-model="cNowSearchKeyWord" @click:append="GetChangeManagerlog()" @keyup.enter="GetChangeManagerlog()" append-icon="search" label="검색어" placeholder="이름" persistent-placeholder class="hidden-md-and-down" dense hide-details></v-text-field>
              </div>
              <IronDate ref="IronDateRef" v-model="sNowSelectDate" @update="onDateRangeChange" cLabel="신청일자" style="width:100%" class="hidden-lg-and-up"/>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="cState"
                :items="zDefaultState"
                @change="GetChangeManagerlog()"
                label="진행상태"
                class="hidden-lg-and-up"
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="cManagerState"
                :items="zCorpManager"
                @change="GetChangeManagerlog()"
                label="정/부 협력업체 관리자"
                class="hidden-lg-and-up"
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="cNowSearchKeyWord" @click:append="GetChangeManagerlog()" @keyup.enter="GetChangeManagerlog()" append-icon="search" label="검색어" placeholder="접수구성원" persistent-placeholder class="hidden-lg-and-up" dense hide-details></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="ma-4">
        <div align="right" class="pa-2 pr-4" id="other_height">
          <v-btn @click="GoReqPage()" dark small class="pl-4 pr-2">
            신청<v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>

        <v-data-table
          v-resize="onResize"
          :items="Records"
          :headers="headers"
          :single-select="bSingleSelect"
          @click:row="handleClick"
          @dblclick:row="handleDoubleClick(selected[0])"
          v-model="selected"
          :items-per-page="15"
          item-key="cReqId"
          :height="ChangableHeight"
          fixed-header
        >
          <template v-slot:item.cCreateDateTime="{ item }">
            {{item.cCreateDateTime.substring(0,10)}}
          </template>
          <template v-slot:item.cCorpNm="{ item }">
            <div v-if="item.cLocal == 'Y'">{{item.cCorpNmKor}}</div>
            <div v-else>{{item.cCorpNmEng}}</div>
          </template>
          <template v-slot:item.cManagerState="{ item }">
            <v-chip label small :color="getManagerStateColor(item.cManagerState)" dark>{{ getManagerState(item.cManagerState) }}</v-chip>
          </template>
          <template v-slot:item.cReqState="{ item }">
            <v-chip label small :color="getReqStateColor(item.cReqState)" dark>{{ getReqState(item.cReqState) }}</v-chip>
          </template>
          <template v-slot:item.cChangeCustomNm="{ item }">
            <div v-if="item.cReqState == 'S'">{{item.cChangeCustomNm}}</div>
          </template>
          <template v-slot:item.cState="{ item }">
            <v-chip label small :color="getStateColor(item.cState)" dark>{{ getState(item.cState) }}</v-chip>
          </template>
          <template v-slot:item.cEndComment="{ item }">
            <div v-if="((item.cCustomId == CustomInfo.CustomId && item.cCorpId == CustomInfo.CorpId && CustomInfo.Manager == 'N') || ((CustomInfo.Manager == 'S' || CustomInfo.Manager == 'M') && item.cCorpId == CustomInfo.CorpId )) && item.cState != 'R'">
              <!-- <div v-if="((item.cCustomId == CustomInfo.CustomId && CustomInfo.Manager == 'N') || ((CustomInfo.Manager == 'S' || CustomInfo.Manager == 'M') && (item.cCorpId == CustomInfo.CorpId || item.cCustomId == CustomInfo.CustomId) )) && item.cState != 'R'"> -->
              <v-btn @click="ShowComment(item,item.cState)" icon><v-icon>mdi-account-details-outline</v-icon></v-btn>
              <!-- <v-btn @click="OpenDialog(item)" icon><v-icon>mdi-account-details-outline</v-icon></v-btn> -->
            </div>
          </template>
          <template v-slot:item.cEdit="{ item }">
            <div v-if="item.cCustomId == CustomInfo.CustomId && item.cCorpId == CustomInfo.CorpId && item.cState == 'R'" class="d-flex">
              <v-btn @click="OpenDialog(item)" icon><v-icon>mdi-pencil</v-icon></v-btn>
              <v-btn @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
            </div>
            <!-- <div class="d-flex">
              <div v-if="item.cCustomId == CustomInfo.CustomId && item.cCorpId == CustomInfo.CorpId && (item.cState == 'R' || item.cState == 'N')">
                <v-btn @click="OpenDialog(item)" icon><v-icon>mdi-pencil</v-icon></v-btn>
              </div>
              <div v-if="item.cCustomId == CustomInfo.CustomId && item.cCorpId == CustomInfo.CorpId && item.cState == 'R'">
                <v-btn @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
              </div>
            </div> -->
          </template>
          <template v-slot:no-data>
            <div class="black--text">{{cNoMsg}}</div>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <div v-else class="word_keeper">
      <v-card class="ma-4">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">mdi-account-switch-outline</v-icon>협력업체 관리자 신청
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
      </v-card>

      <v-card class="ma-4 pt-2 pb-2">
        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            협력업체 관리자 서약서
          </v-card-subtitle>
        </v-toolbar>
         <!-- essetial_card -->
        <v-card outlined tile class="mr-4 ml-4 mt-0 pa-6">
          <v-row>
            <v-col cols="12" class="d-flex">
              본인은 {{sFormatCorpNm}} 업체의 관리자로서 {{$store.state.CustomInfo.SiteNm}} 출입에 따른 보안사고 방지에 철저를 기할 것이며,
              보안사항에 대해 출입 기간은 물론 그 이후라도 외부에 절대 누설되지 않도록 출입자에게 교육시키고 철저히 감독할 것과 만일 위 사항을 위반하였을 때는
              모든 책임이 본인에게 있으며, 방문증 분실로 인한 제재조치, 재발급비용 납부 등을 포함한 회사의 어떠한 조치도 감수할 것을 서약 합니다.
            </v-col>
            <v-col cols="12">
              협력업체 관리자 이행사항<br>
              <div class="pl-6">
                <div class="d-flex">1.&nbsp;<div>방문증 발급에 필요한 제반 서류의 이상 여부 확인 및 이에 대한 책임</div></div>
                <div class="d-flex">2.&nbsp;<div>출입 사유 종료 시 즉시 방문증 반납</div></div>
                <div class="d-flex">3.&nbsp;<div>방문증 발급대상자의 보안 교육 이수 안내</div></div>
                <div class="d-flex">4.&nbsp;<div>소속직원의 방문증 분실 시 24시간 이내 신고</div></div>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="d-flex align-center justify-space-around">
                <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height:70px"/>
                <v-checkbox v-model="bPledgeCheck" dense class="mt-2" color="black">
                  <template v-slot:label>
                    <div class="black--text">
                      서약합니다.
                    </div>
                  </template>
                </v-checkbox>
              </div>
            </v-col>
          </v-row>
        </v-card>
      
        <v-toolbar dense flat color="white" class="mt-4">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            협력업체 관리자 신청
          </v-card-subtitle>
        </v-toolbar>
        <v-tabs class="mr-4 ml-4" v-model="bChange" @change="InitializeReq()">
          <v-tab center-active class="text-subtitle-1 font-weight-bold">신규</v-tab>
          <v-tab center-active class="text-subtitle-1 font-weight-bold">변경</v-tab>
        </v-tabs>

        <v-card outlined tile class="ma-4 mt-0 pa-6 pb-2">
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.CustomNickId" label="ID" disabled dense persistent-hint persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.CustomNm" label="이름" disabled dense persistent-hint persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.Tel" label="휴대전화 번호" disabled dense persistent-hint persistent-placeholder></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        
        <v-card outlined tile class="ma-4 mb-0 essetial_card">
          <v-card-text class="mt-2 mb-2">
            <v-row>
              <v-col cols="12" sm="6" md="3" v-if="bChange == 1">
                <v-text-field v-model="editedItem.cChangeCustomNm" @keyup="editedItem.cChangeCustomId = ''" @keyup.enter="SearchManagerDialog()" @click:append="SearchManagerDialog()" placeholder="이름으로 검색" append-icon="search" dense persistent-hint persistent-placeholder>
                  <template v-slot:label>
                    기존 관리자<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-radio-group v-model="editedItem.cManagerState" @change="ResetManagerInfo()" dense mandatory row class="mt-0" style="min-width:230px;">
                  <v-radio :disabled="CustomInfo.Manager == 'M' && bChange == 1 " value="M" label="정 관리자"></v-radio>
                  <v-radio :disabled="CustomInfo.Manager == 'S' && bChange == 1 " value="S" label="부 관리자"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="editedItem.cWork" dense auto-grow rows="1" persistent-placeholder hint="100자 내로 입력하여 주세요." counter :rules="[rules.counter]" maxlength="100">
                  <template v-slot:label>
                    SK 관련 주요 업무<strong class="red--text">*</strong>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-toolbar dense flat color="white" class="mt-4">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            첨부파일
          </v-card-subtitle>
        </v-toolbar>
        <v-card outlined tile class="ma-4 mt-0 pa-6 essetial_card">
          <v-row>
            <v-col cols="12">
              <div class="d-flex flex-wrap">
                <div style="width:150px">
                  사업자 등록증
                </div>
                <v-img
                  :aspect-ratio="1/1"
                  :src="sNowPath1"
                  contain
                  class="ml-4 mr-4"
                  style="width:100px"
                  max-width="150px"
                  max-height="150px"
                ></v-img>
                <v-file-input
                  v-on:change="onSelFile(NowSelFile1,1)"
                  v-model="NowSelFile1"
                  class="mt-2 mb-2"
                  accept="image/png"
                  placeholder="파일선택"
                  hint="Essential"
                  style="max-width : 300px"
                  persistent-hint
                  dense
                >
                  <template v-slot:message>
                    <div class="mb-1">JPG,JPEG,PNG,GIF파일만 첨부하세요.</div>
                    <div class="mb-1">최대 10MB 까지 첨부가능 합니다.</div>
                    다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
                  </template>
                </v-file-input>
              </div>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
              <div class="d-flex flex-wrap">
                <div style="width:150px">
                  협력업체 관리자<br>
                  보안 서약서<br>
                  <v-btn @click="DownloadFile(2)" dark small>[양식 다운로드]</v-btn>
                </div>
                <v-img
                  :aspect-ratio="1/1"
                  :src="sNowPath2"
                  contain
                  class="ml-4 mr-4"
                  style="width:100px"
                  max-width="150px"
                  max-height="150px"
                ></v-img>
                <v-file-input
                  v-on:change="onSelFile(NowSelFile2,2)"
                  v-model="NowSelFile2"
                  class="mt-2 mb-2"
                  accept="image/png"
                  placeholder="파일선택"
                  hint="Essential"
                  style="max-width : 300px"
                  persistent-hint
                  dense
                >
                  <template v-slot:message>
                    <div class="mb-1">JPG,JPEG,PNG,GIF파일만 첨부하세요.</div>
                    <div class="mb-1">최대 10MB 까지 첨부가능 합니다.</div>
                    다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
                  </template>
                </v-file-input>
              </div>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
              <div class="d-flex flex-wrap">
                <div style="width:150px">
                  위임장<br>
                  <v-btn @click="DownloadFile(3)" dark small>[양식 다운로드]</v-btn>
                </div>
                <v-img
                  :aspect-ratio="1/1"
                  :src="sNowPath3"
                  contain
                  class="ml-4 mr-4"
                  style="width:100px"
                  max-width="150px"
                  max-height="150px"
                ></v-img>
                <v-file-input
                  v-on:change="onSelFile(NowSelFile3,3)"
                  v-model="NowSelFile3"
                  class="mt-2 mb-2"
                  accept="image/png"
                  placeholder="파일선택"
                  hint="Essential"
                  style="max-width : 300px"
                  persistent-hint
                  dense
                >
                  <template v-slot:message>
                    <div class="mb-1">JPG,JPEG,PNG,GIF파일만 첨부하세요.</div>
                    <div class="mb-1">최대 10MB 까지 첨부가능 합니다.</div>
                    다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
                  </template>
                </v-file-input>
              </div>
            </v-col>
          </v-row>
        </v-card>

        <v-divider class="mr-4 ml-4"></v-divider>
        <div class="ma-4" align="center">
          <v-btn @click="BackStatus()" text class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>목록</v-btn>
          <v-btn @click="SetChangeManagerLog()" dark class="ml-2"><v-icon class="mr-2">post_add</v-icon>신청</v-btn>
        </div>
      </v-card>
    </div>
    <SearchManager ref="SearchManagerRef" @SelectManager="SelectManager"/>
    <EditChangeManagerDialog ref="EditChangeManagerDialogRef" @ChangeReq="ChangeReq"/>
    <DelDialog ref="DelDialogRef" @DelChangeManagerData="DelChangeManagerData"/>
    <ResponseDialog ref="ResponseDialogRef"/>
  </div>
</template>

<script>
import Util from "../Util.js";
import { mapState } from "vuex";
import EventBus from '@/eventBus.js';
import axios from "axios"
import BasicInfo from "@/BasicInfo.js";

import IronDate from '@/components/iron28Calendar/src/IronDate3.vue';

import SearchManager from "./SearchManager.vue";
import EditChangeManagerDialog from '../components/EditChangeManagerDialog.vue'
import DelDialog from '../components/DelDialog.vue'
import ResponseDialog from "../components/ResponseDialog.vue";

export default {
  components: {
    IronDate,
    SearchManager,
    EditChangeManagerDialog,
    DelDialog,
    ResponseDialog
  },

  data: () => ({
    bPledgeCheck : false,
    loading : false,
    bChange : 0,
    ChangableHeight : "",
    cNoMsg : "",
    bApplyDate : true,
    bSingleSelect : true,
    cInputCorpNm : "",
    sNowPath1 : "",
    sNowPath2 : "",
    sNowPath3 : "",
    ReqMode : true,
    NowSelFile1 : null,
    NowSelFile2 : null,
    NowSelFile3 : null,
    sNowSelectDate :  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth()),
    sStartDate : Util.sFormatDate(Util.sBefore1Moth()),
    sEndDate : Util.sFormatDate(Util.sAfter1Moth()),
    cNowSearchKeyWord : "",
    cManagerState : "ALL",
    cState : "ALL",
    Records : [],
    selected : [],
    headers : [
      { text: 'No', value: 'sNum', width : "10"},
      { text: '신청일자', value: 'cCreateDateTime',width : "120" },
      { text: 'ID', value: 'cCustomNickId' },
      { text: '이름', value: 'cCustomNm' },
      { text: '소속', value: 'cCorpNm' },
      { text: '전화번호', value: 'cTel' },
      { text: '정/부', value: 'cManagerState' },
      { text: '신규/구분', value: 'cReqState' },
      { text: '기존 관리자', value: 'cChangeCustomNm' },
      { text: '상태', value: 'cState',align : "center"},
      { text: '의견', value: 'cEndComment',width:"80",align : "center"},
      { text: '작업', value: 'cEdit',width:"80",align : "center"},
    ],
    rules: {
      counter: value => value.length < 100 || '입력 가능한 최대 글자 수를 입력하셨습니다.',
    },
    editedItem: {
      cCorpNm : "",
      cChangeCustomId : "",
      cChangeCustomNm : "",
      cWork : "",
      cManagerState : "",
      cFileId1 : "",
      cFileId2 : "",
      cFileId3 : "",
    },
    defaulteditedItem: {
      cCorpNm : "",
      cChangeCustomId : "",
      cChangeCustomNm : "",
      cWork : "",
      cManagerState : "",
      cFileId1 : "",
      cFileId2 : "",
      cFileId3 : "",
    },
  }),

  computed: {
    ...mapState(["CustomInfo","zDefaultState","zCorpManager","zRSState","zFileType","zState","FMaxSize3","oManagerSec","oWarrant"]),
    sFormatCorpNm () {
      if (this.CustomInfo.Local == "Y") {
        return this.CustomInfo.CorpNmKor
      } else {
        return this.CustomInfo.CorpNmEng
      }
    }
  },

  mounted () {
    this.Initialize();
  },

  created () {
  },

  methods: {
    onResize(){
      let h1 = document.getElementById('footer_height').clientHeight
      let h2 = document.getElementById('head_height').clientHeight
      let h3 = document.getElementById('other_height').clientHeight

      let iCalcHeight = window.innerHeight - h1 - h2 - h3 - 136

      if (iCalcHeight >= 300) {
        this.ChangableHeight = String(iCalcHeight) + "px"
      } else {
        this.ChangableHeight = "300px"
      }
    },

    Initialize() {
      this.ReqMode = false;
      this.bApplyDate = true;
      this.cNowSearchKeyWord = "";
      this.cManagerState = "ALL";
      this.cState = "ALL";
      this.sNowSelectDate =  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth());
      this.sStartDate = Util.sFormatDate(Util.sBefore1Moth());
      this.sEndDate = Util.sFormatDate(Util.sAfter1Moth());
      this.GetChangeManagerlog();
    },
    
    InitializeReq() {
      this.bPledgeCheck = false
      this.editedItem  = Object.assign({}, this.defaulteditedItem);

      this.NowSelFile1 = null
      this.NowSelFile2 = null
      this.NowSelFile3 = null
      this.sNowPath1 = this.sNowPath2 = this.sNowPath3 = ""
    },

    ResetManagerInfo() {
      let BeforeReset = this.editedItem.cManagerState
      this.editedItem  = Object.assign({}, this.defaulteditedItem);
      this.editedItem.cManagerState = BeforeReset

      this.NowSelFile1 = null
      this.NowSelFile2 = null
      this.NowSelFile3 = null
      this.sNowPath1 = this.sNowPath2 = this.sNowPath3 = ""
    },

    onDateRangeChange(daterange) {
      this.sStartDate = Util.sFormatDate(daterange.startDate);
      this.sEndDate = Util.sFormatDate(daterange.endDate);
      this.sNowSelectDate = this.sStartDate + " ~ " +  this.sEndDate;
      this.GetChangeManagerlog();
    },

    getManagerStateColor(cState){
      return this.zCorpManager.find((e) => {return e.value == cState})?.color
    },

    getManagerState(cState){
      return this.zCorpManager.find((e) => {return e.value == cState})?.text
    },

    getReqStateColor(cState){
      return this.zRSState.find((e) => {return e.value == cState})?.color
    },

    getReqState(cState){
      return this.zRSState.find((e) => {return e.value == cState})?.text
    },

    getStateColor(cState){
      return this.zDefaultState.find((e) => {return e.value == cState})?.color
    },

    getState(cState){
      return this.zDefaultState.find((e) => {return e.value == cState})?.text
    },
    

    handleClick(value) {
      this.selected = [value];
    },

    handleDoubleClick(item){
      if (item.cCustomId != this.CustomInfo.CustomId && item.cCorpId != this.CustomInfo.CorpId) return
      if (item.cCustomId != this.CustomInfo.CustomId && item.cCorpId == this.CustomInfo.CorpId && this.CustomInfo.Manager == 'N') return
      if (item.cCustomId != this.CustomInfo.CustomId && item.cCorpId == this.CustomInfo.CorpId && this.CustomInfo.Manager != "N" && item.cState == "R") return

      if (this.selected.length > 0 || item.cReqId != undefined){
        this.OpenDialog(item)
      }
    },

    ChangeReq(item,index){
      // this.Records.splice(index,1,item)

      this.Records[index].cChangeCustomId = item.cChangeCustomId
      this.Records[index].cChangeCustomNm = item.cChangeCustomNm
      this.Records[index].cManagerState = item.cManagerState
      this.Records[index].cReqState = item.cReqState
      this.Records[index].cWork = item.cWork
      this.Records[index].cFileId1 = item.cFileId1
      this.Records[index].cFileId2 = item.cFileId2
      this.Records[index].cFileId3 = item.cFileId3
      this.Records[index].cFileNm1 = item.cFileNm1
      this.Records[index].cFileNm2 = item.cFileNm2
      this.Records[index].cFileNm3 = item.cFileNm3
      // this.Records[index].cFilePath1 = item.cFilePath1
      // this.Records[index].cFilePath2 = item.cFilePath2
      // this.Records[index].cFilePath3 = item.cFilePath3
    },

    OpenDialog(item){
      if (item.cState == BasicInfo.REQ_TYPE_CCORP_STATE_REQ) {
        let EditIndex = this.Records.indexOf(item);
        this.$refs.EditChangeManagerDialogRef.ShowDialog(item,EditIndex);
      } else {
        this.ShowComment(item,item.cState)
      }
    },

    ShowComment(oitem,StateNm) {
      // let stateValue = this.getState(StateNm) || ""; // null 체크 추가
      // console.log("StateNm:", StateNm, "Resolved State:", stateValue); 
      this.$refs.ResponseDialogRef.ShowDialog(oitem,this.getState(StateNm),false)
    },

    ShowDelDialog(item){
      this.$refs.DelDialogRef.ShowDialog("ChangeCM",item,this.Records.indexOf(item));
    },

    DelChangeManagerData(index,item){
      this.DelChangeManagerlog(index,item)
    },

    ShowNoResultMsg() {
      this.cNoMsg = ""

      setTimeout(() => {
        this.cNoMsg = "검색된 방문자가 없습니다."
      }, 300);
    },

    GetChangeManagerlog(){
      this.Records = [];

      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        State : this.cState,
        Manager : this.CustomInfo.Manager,
        ManagerState : this.cManagerState,
        StartDate : this.sStartDate,
        EndDate : this.sEndDate,
        ApplyDate : this.bApplyDate,
        NowSearchKeyWord : this.cNowSearchKeyWord,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "GetChangeManagerlog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length > 0) {
              for (let i =0; i < res.data.Result.length; i++){
                res.data.Result[i].sNum = i+1
              }
            } else {
              this.ShowNoResultMsg();
            }

            this.Records = res.data.Result
            this.bApplyDate = false
          } else if (res.data.ResultCd == BasicInfo.ERROR_CODE_CHECK_RIGHT_CUSTOM) {
            EventBus.$emit("onShowMsgBox", "정보 조회가 불가 합니다.","소속업체 또는 관리자 권한이 변경되었을 수 있습니다.\n새로고침 버튼을 눌러 주세요.");
            this.ShowNoResultMsg();
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    GoReqPage() {
      this.ReqMode = true;
    },

    SearchManagerDialog() {
      this.$refs.SearchManagerRef.ShowDialog(this.editedItem)
    },

    SelectManager(Selected) {
      this.editedItem.cChangeCustomId = Selected.cCustomId
      this.editedItem.cChangeCustomNm = Selected.cCustomNm
    },

    onSelFile(NowSelFile,FileCase) {
      let bFileType = false

      if (NowSelFile != null)  {
        if (NowSelFile.size > this.FMaxSize3)  {
          setTimeout(() => {
            if (FileCase == 1) {
              this.sNowPath1 = ""
              this.NowSelFile1 = null;
            }

            if (FileCase == 2) {
              this.sNowPath2 = ""
              this.NowSelFile2 = null;
            }

            if (FileCase == 3) {
              this.sNowPath3 = ""
              this.NowSelFile3 = null;
            }
          }, 10);

          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
      }

      if (!bFileType) {
        setTimeout(() => {
          if (FileCase == 1) this.NowSelFile1 = null;  
          if (FileCase == 2) this.NowSelFile2 = null;
          if (FileCase == 3) this.NowSelFile3 = null;
        }, 300);

        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      this.loading = true
      const reader = new FileReader

      reader.onload = e => {
        var imageData = e.target.result;

        if (FileCase == 1) this.sNowPath1 = imageData;
        if (FileCase == 2) this.sNowPath2 = imageData;
        if (FileCase == 3) this.sNowPath3 = imageData;

        this.loading = false;
      }
      try {
        this.loading = false;
        reader.readAsDataURL(NowSelFile)
      }
      catch (error) {
        if (FileCase == 1) this.sNowPath1 = "";
        if (FileCase == 2) this.sNowPath2 = "";
        if (FileCase == 3) this.sNowPath3 = "";
        
        this.loading = false;
        EventBus.$emit("onFileBus", true,""+error);
        // EventBus.$emit("onShowMsg", true,""+error);
      }
    },

    DownloadFile(DownCase) {
      let FilePath = ""
      let FileNm = ""

      if (DownCase == 2) {
        FilePath = this.oManagerSec.FilePath + this.CustomInfo.SiteId + ".pdf"
        FileNm = this.oManagerSec.FileNm
      } else {
        FilePath = this.oWarrant.FilePath + this.CustomInfo.SiteId + ".pdf"
        FileNm = this.oWarrant.FileNm
      }

      console.log(process.env.VUE_APP_FILE_API + FilePath);

      axios({
        url: process.env.VUE_APP_FILE_API + FilePath,
        method: 'GET',
        responseType: 'blob', 
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', FileNm); 
          document.body.appendChild(link);
          link.click();
        });      
    },


    BackStatus() {
      this.InitializeReq();
      this.Initialize();
    },

    bSendSvrFile(NowSelFile){
      var d = new Date();
      var Year = d.getFullYear(); 
      
      var fileName = NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadauthfile', NowSelFile);
      return new Promise((resolve) => (
        axios.post(process.env.VUE_APP_UIL_API + "UploadAuthFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+NowSelFile.type+"&Size="+NowSelFile.size+"&FileTypeId="+sFileTypeId+"&CustomId="+this.CustomInfo.CustomId+"&SiteId="+this.CustomInfo.SiteId,
                formData,
                {
                headers: {
                  'Content-Type' : 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              resolve(null);
              EventBus.$emit("onShowMsg",true, "파일저장에 실패하였습니다. 관리자에게 문의 바랍니다." + err)
          })
      ));
    },

    async SetChangeManagerLog() {
      if (!this.bPledgeCheck) {
        EventBus.$emit("onShowMsgBox", "관리자 서약서에 서약 해주세요.", "서약하기 옆의 체크박스를 클릭해 주세요.");
        return
      }
      if (this.editedItem.cChangeCustomId == "" && this.bChange == 1) {
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "기존 관리자를 입력(선택) 하여 주세요.");
        return
      }
      if (this.editedItem.cWork == "") {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.", this.$store.state.CustomInfo.SiteNm + " 관련 주요 업무를 입력 하여 주세요.");
        return
      }
      if (this.NowSelFile1 == null) {
        EventBus.$emit("onShowMsgBox", "사진을 첨부하여 주세요.", "사업자 등록증을 첨부하여 주세요.");
        return
      }
      if (this.NowSelFile2 == null) {
        EventBus.$emit("onShowMsgBox", "사진을 첨부하여 주세요.", "보안 서약서를 첨부하여 주세요.");
        return
      }
      if (this.NowSelFile3 == null) {
        EventBus.$emit("onShowMsgBox", "사진을 첨부하여 주세요.", "위임장을 첨부하여 주세요.");
        return
      }

      this.loading = true;

      if (this.NowSelFile1 != null) {
        var res1 = await this.bSendSvrFile(this.NowSelFile1);
        if (res1.data.ResultCd == "00") {
          this.editedItem.cFileId1 = res1.data.FileId;
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }

      if (this.NowSelFile2 != null) {
        var res2 = await this.bSendSvrFile(this.NowSelFile2);
        if (res2.data.ResultCd == "00") {
          this.editedItem.cFileId2 = res2.data.FileId;
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }
      
      if (this.NowSelFile3 != null) {
        var res3 = await this.bSendSvrFile(this.NowSelFile3);
        if (res3.data.ResultCd == "00") {
          this.editedItem.cFileId3 = res3.data.FileId;
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }

      var posData = {
        SiteId : this.CustomInfo.SiteId, 
        CustomId : this.CustomInfo.CustomId,
        CorpNm : Util.ChangeCorpNm3Data(this.CustomInfo.Local,this.CustomInfo.CorpNmKor,this.CustomInfo.CorpNmEng),
        CorpId : this.CustomInfo.CorpId,
        CustomNm : this.CustomInfo.CustomNm,
        ChangeCustomId : this.editedItem.cChangeCustomId,
        Manager : this.CustomInfo.Manager,
        ManagerState : this.editedItem.cManagerState,
        ReqState : "",
        Work : this.editedItem.cWork,
        FileId1  : this.editedItem.cFileId1,
        FileId2  : this.editedItem.cFileId2,
        FileId3  : this.editedItem.cFileId3,
      };
      
      if (this.bChange == 1) {
        posData.ReqState = "S"
      } else {
        posData.ChangeCustomId = "NONE"
        posData.ReqState = "F"
      }


      axios
        .post(process.env.VUE_APP_UIL_API + "SetChangeManagerLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.bPledgeCheck = false;
            this.BackStatus();
            EventBus.$emit("onShowMsg",false,  "신청이 완료 되었습니다.");
          // } else if (res.data.ResultCd == "02") {
          //   EventBus.$emit("onShowMsgBox", "관리자에게 문의 바랍니다.", res.data.Msg);
          } else if (res.data.ResultCd == "04") {
            EventBus.$emit("onShowMsgBox", "삭제 처리된 아이디 입니다.", "로그인 화면으로 이동합니다.");
            this.$store.dispatch('logout',"DelCustomId");
          } else if (res.data.ResultCd == "05") {
            EventBus.$emit("onShowMsgBox", "신청 가능한 최대 인원수를 넘었습니다.", res.data.Msg);
          } else if (res.data.ResultCd == "08") {
            EventBus.$emit("onShowMsgBox", "선택하신 관리자에 대하여 변경 진행 중인 결재건이 있습니다.", "소속업체의 관리자나 직원에게 변경 진행 중인 신청건이 있는지 확인하여 주세요.");
          } else if (res.data.ResultCd == "09") {
            EventBus.$emit("onShowMsgBox", "관리자 권한이 해지된 사용자 입니다.", "변경을 원하시는 관리자를 선택하여 주세요.");
          } else if (res.data.ResultCd == "10") {
            EventBus.$emit("onShowMsgBox", "관리자 권한이 변동되었습니다.", "화면을 다시 접속하여 확인 하여 주세요.");
          } else if (res.data.ResultCd == "11") {
            EventBus.$emit("onShowMsgBox", "선택하신 관리자는 삭제된 회원 입니다.", "새로운 관리자를 선택하여 주세요.");
          } else if (res.data.ResultCd == "12") {
            EventBus.$emit("onShowMsgBox", "신규 신청이 불가 합니다.", "신규 신청을 원하시면 관리자 권한에 대한 해지 절차를 진행 하여 주세요.");
          } else if (res.data.ResultCd == "14") {
            EventBus.$emit("onShowMsgBox", "기존에 신청 중인 내역이 존재 합니다.", "신청 중인 건을 삭제 하거나 결재가 완료한 후 신청을 진행하여 주세요.");
          } else if (res.data.ResultCd == "55") {
            EventBus.$emit("onShowMsgBox","출입 정지 기간 중입니다.", res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          this.loading = false;
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    DelChangeManagerlog(index,item) {
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        ChangeCustomId : item.cChangeCustomId,
        CorpId : this.CustomInfo.CorpId,
        ReqId : item.cReqId,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "DelChangeManagerLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.Records.splice(index,1)
            // for (let i = 0; i < this.Records.length;i ++){
            //   this.Records[i].sNum = i+1
            // }
            EventBus.$emit("onShowMsg",false,"삭제가 완료되었습니다.");
          } else if (res.data.ResultCd === "04") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },
  }
};
</script>

<style>

</style>